import type { Theme } from './types';
import type { TilePalette } from './palettes';

// Board / score / overlay colors are read from CSS custom properties once and cached.
// Tile colors come from the active palette (swapped without touching CSS).

interface BaseColors {
  pageBg:     string;
  boardBg:    string;
  cellEmpty:  string;
  scoreBg:    string;
  scoreText:  string;
  scoreLabel: string;
  tileBorder: string;
  overlayWin:  string;
  overlayLose: string;
  overlayText: string;
}

let _base: BaseColors | null = null;

function getBase(): BaseColors {
  if (_base) return _base;
  const s = getComputedStyle(document.documentElement);
  const v = (n: string) => s.getPropertyValue(n).trim();
  _base = {
    pageBg:     v('--page-bg'),
    boardBg:    v('--board-bg'),
    cellEmpty:  v('--cell-empty'),
    scoreBg:    v('--score-bg'),
    scoreText:  v('--score-text'),
    scoreLabel: v('--score-label'),
    tileBorder: v('--tile-border'),
    overlayWin:  v('--overlay-win'),
    overlayLose: v('--overlay-lose'),
    overlayText: v('--overlay-text'),
  };
  return _base;
}

// Build (or rebuild) the full Theme from the current CSS base + chosen palette.
// palette.board (when defined) overrides the CSS-sourced board/score colors,
// which allows alt palettes to set white page bg, tinted board, etc.
// Call once at startup and again whenever the user switches palettes.
export function buildTheme(palette: TilePalette): Theme {
  const base = getBase();
  return {
    ...base,
    ...(palette.board ?? {}),
    tileBg:   palette.bg,
    tileText: palette.text,
  };
}
